import React, { useState, useEffect } from 'react';

const testimonialsData = [
  {
    name: "Maria Camila",
    university: "U. Sergio Arboleda",
    imgUrl: "https://dufyasesorias.com/wp-content/uploads/2026/06/Screenshot_2025-07-23-14-12-27-468_com.whatsapp.w4b-scaled.jpg" 
  },
  {
    name: "Paula R.",
    university: "U. Católica",
    imgUrl: "https://dufyasesorias.com/wp-content/uploads/2026/06/Screenshot_2025-07-23-14-12-27-468_com.whatsapp.w4b-scaled.jpg" 
  },
  {
    name: "Camilo C.",
    university: "U. Sergio Arboleda",
    imgUrl: "https://dufyasesorias.com/wp-content/uploads/2026/06/Screenshot_2025-07-23-14-12-27-468_com.whatsapp.w4b-scaled.jpg" 
  },
  {
    name: "Melissa M.",
    university: "U. Central",
    imgUrl: "https://dufyasesorias.com/wp-content/uploads/2026/06/Screenshot_2025-07-23-14-12-27-468_com.whatsapp.w4b-scaled.jpg" 
  },
  {
    name: "Javier R.",
    university: "U. Nacional",
    imgUrl: "https://dufyasesorias.com/wp-content/uploads/2026/06/Screenshot_2025-07-23-14-12-27-468_com.whatsapp.w4b-scaled.jpg" 
  },
  {
    name: "Sofía P.",
    university: "U. Católica",
    imgUrl: "https://dufyasesorias.com/wp-content/uploads/2026/06/Screenshot_2025-07-23-14-12-27-468_com.whatsapp.w4b-scaled.jpg" 
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(1);

  // Detectar de forma dinámica cuántas tarjetas se muestran según la pantalla
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setItemsPerView(4); // Computadora: 4 columnas
      } else if (window.innerWidth >= 640) {
        setItemsPerView(2); // Tablet: 2 columnas
      } else {
        setItemsPerView(1); // Celular: 1 columna
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Temporizador de desplazamiento automatizado 1 a 1
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const maxIndex = testimonialsData.length - itemsPerView;
        return prevIndex >= maxIndex ? 0 : prevIndex + 1;
      });
    }, 3500); // Rota cada 3.5 segundos

    return () => clearInterval(timer);
  }, [itemsPerView]);

  // CORREGIDO: Ahora la función devuelve la propiedad de transformación CSS completa con su envoltorio
  const getTranslateX = () => {
    if (itemsPerView === 4) {
      return `translateX(calc(-${currentIndex * 25}% - ${currentIndex * 6}px))`;
    }
    if (itemsPerView === 2) {
      return `translateX(calc(-${currentIndex * 50}% - ${currentIndex * 12}px))`;
    }
    return `translateX(calc(-${currentIndex * 100}% - ${currentIndex * 24}px))`;
  };

  return (
    <section id="testimonials" className="py-16 px-6 lg:px-16 bg-[#023554] text-center overflow-hidden scroll-mt-20">
      
      <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight mb-12">
        Testimonios
      </h2>

      {/* CONTENEDOR MÁSCARA DEL CARRUSEL */}
      <div className="max-w-6xl mx-auto relative">
        
        <div className="overflow-hidden p-2">
          <div 
            className="flex transition-transform duration-700 ease-in-out gap-6"
            style={{ transform: getTranslateX() }}
          >
            {testimonialsData.map((item, idx) => (
              <div 
                key={idx} 
                className="w-full sm:w-[calc(50%-12px)] lg:w-[calc(25%-18px)] flex-shrink-0 flex flex-col items-center group text-center"
              >
                
                {/* Cuadro contenedor de la captura */}
                <div className="w-full bg-white rounded-2xl overflow-hidden shadow-xl border border-slate-900/20 aspect-[4/3] flex items-center justify-center transition-transform duration-300 group-hover:scale-[1.02]">
                  <img 
                    src={item.imgUrl} 
                    alt={`Evidencia de ${item.name}`}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentNode.innerHTML = `
                        <div class="p-4 text-slate-400 font-semibold text-xs bg-slate-50 w-full h-full flex items-center justify-center border border-dashed border-slate-200 rounded-2xl">
                          Captura de Chat (${item.name})
                        </div>
                      `;
                    }}
                  />
                </div>

                {/* Identificación del Estudiante */}
                <h3 className="mt-4 font-bold text-white text-base md:text-lg tracking-tight">
                  {item.name}
                </h3>
                <p className="text-slate-300 text-xs font-medium mt-0.5">
                  {item.university}
                </p>

              </div>
            ))}
          </div>
        </div>

        {/* INDICADORES / PAGINACIÓN EN PUNTOS */}
        <div className="flex justify-center gap-2 mt-10">
          {Array.from({ length: testimonialsData.length - itemsPerView + 1 }).map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className={`h-2 rounded-full transition-all duration-300 ${
                currentIndex === idx ? 'w-6 bg-white' : 'w-2 bg-white/30 hover:bg-white/60'
              }`}
              aria-label={`Ver caso ${idx + 1}`}
            />
          ))}
        </div>

      </div>

    </section>
  );
};

export default Testimonials;